import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { supabase } from '@unvld/db'
import { useAuth } from '../stores/auth'

export function AuthCallback() {
  const navigate = useNavigate()
  const init = useAuth((s) => s.init)

  useEffect(() => {
    supabase.auth.onAuthStateChange((event) => {
      if (event === 'SIGNED_IN') {
        init().then(() => navigate('/', { replace: true }))
      }
    })
  }, [])

  return (
    <div className="min-h-screen bg-slate-950 flex items-center justify-center">
      <div className="text-center">
        <div className="w-12 h-12 border-4 border-indigo-500 border-t-transparent rounded-full animate-spin mx-auto" />
        <p className="text-slate-400 mt-4">Anmeldung wird abgeschlossen...</p>
      </div>
    </div>
  )
}
